// extracted by mini-css-extract-plugin
module.exports = {"hightlightLink":"FooterLink_hightlightLink__37TIV","text":"FooterLink_text__3VQjW"};